// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3vazj","title":"BackImages_title__g1Cpr","images":"BackImages_images__5vme5"};